/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_VIEWER_ACTION = "APPROVE" | "CREATE" | "EDIT" | "REJECT" | "%future added value";
export type UnansweredCommentsTabCommentContainer_comment = {
    readonly id: string;
    readonly enteredLive: boolean | null;
    readonly lastViewerAction: COMMENT_VIEWER_ACTION | null;
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_comment" | "ReplyListContainer1_comment" | "IgnoredTombstoneOrHideContainer_comment">;
    readonly " $refType": "UnansweredCommentsTabCommentContainer_comment";
};
export type UnansweredCommentsTabCommentContainer_comment$data = UnansweredCommentsTabCommentContainer_comment;
export type UnansweredCommentsTabCommentContainer_comment$key = {
    readonly " $data"?: UnansweredCommentsTabCommentContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"UnansweredCommentsTabCommentContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [
        {
            "defaultValue": false,
            "kind": "LocalArgument",
            "name": "refreshStream"
        }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "UnansweredCommentsTabCommentContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_comment"
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "refreshStream",
                    "variableName": "refreshStream"
                }
            ],
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_comment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_comment"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enteredLive",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastViewerAction",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = '2ec1338f0a350a2d0f7b70546dcbaf45';
export default node;
